/**
 *******************************************************************************
 * FILE: lgekor-ui/src/js/employee/allianceRegInfo.js
 * Desc : 제휴사 복지몰 회사명 검색 팝업
 *
 * PROJ : 제휴사 복지몰
 *******************************************************************************
 *                  Modification History
 *******************************************************************************
 * CSR No.              DATE                 AUTHOR               DESCRIPTION
 *******************************************************************************
 * BTOCSITE-117982      2026/03/12                                제휴사 복지몰 회사명 검색 팝업
 *******************************************************************************
 **/

 (function() {
    var allianceSearch = {
        apiUrl: {
            searchPartnerList: '/mkt/api/partner/searchPartnerList.lgajax'
        },
        el: {
            $popup: null,
            $searchInput: null,
            $searchBtn: null,
            $tblLayout: null,
            $partnerList: null,
            $noData: null,
            $noticeWrap: null
        },
        data: {
            partnerGrp: 'AFC',
            selectedPartner: null
        },
        init: function() {
            this.el.$popup = $('#searchPopup');
            this.el.$searchInput = this.el.$popup.find('#inp-search');
            this.el.$searchBtn = this.el.$popup.find('.btn-search');
            this.el.$tblLayout = this.el.$popup.find('.tbl-layout');
            this.el.$partnerList = this.el.$popup.find('#disp-partner-list');
            this.el.$noData = this.el.$popup.find('.no-data');
            this.el.$noticeWrap = this.el.$popup.find('.notice-wrap');

            this.initDisplay();
            this.bindEvent();
        },

        initDisplay: function() {
            this.el.$tblLayout.hide();
            this.el.$noticeWrap.hide();
            this.el.$noData.show();
            this.el.$noData.find('p').hide();
            this.el.$noData.find('p').eq(0).show();
            this.el.$noData.find('.desc').hide();
            this.el.$noData.find('.btn-inquiry').hide();
        },

        bindEvent: function() {
            this.el.$searchBtn.on('click', function() {
                if (allianceSearch.el.$searchInput.val().length < 2) {
                    lgkorUI.alert("", { title: "최소 2자 이상 입력해 주세요.", ok: function() {} }, allianceSearch.el.$searchInput);
                    return;
                }
                allianceSearch.searchPartnerList();
            });

            this.el.$searchInput.on('keydown', function(e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    allianceSearch.el.$searchBtn.trigger('click');
                }
            });

            this.el.$popup.on('click', '#disp-partner-list .row', function() {
                var $row = $(this);
                allianceSearch.el.$popup.find('#disp-partner-list .row').removeClass('active');
                $row.addClass('active');

                allianceSearch.data.selectedPartner = {
                    partnerCd: $row.data('partner_cd'),
                    partnerNm: $row.data('partner_nm'),
                    emailDomain: $row.data('email_domain'),
                    authType: $row.data('auth_type'),
                    authTypeText: $row.data('auth_type_text')
                };
            });
        },

        searchPartnerList: function() {
            var sendUrl = allianceSearch.apiUrl.searchPartnerList;

            var requestData = {
                partnerNm: allianceSearch.el.$searchInput.val(),
                partnerGrp: allianceSearch.data.partnerGrp
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result) {
                var data = result.data[0];

                if (Object.keys(data.partnerList).length > 0) {
                    allianceSearch.el.$partnerList.html(vcui.template(partnerRowTmpl, data));
                    allianceSearch.el.$tblLayout.show();
                    allianceSearch.el.$noticeWrap.show();
                    allianceSearch.el.$noData.hide();
                } else {
                    allianceSearch.el.$tblLayout.hide();
                    allianceSearch.el.$noticeWrap.hide();
                    allianceSearch.el.$noData.show();
                    allianceSearch.el.$noData.find('p').eq(0).hide();
                    allianceSearch.el.$noData.find('p').eq(1).show();
                    allianceSearch.el.$noData.find('.desc').show();
                    allianceSearch.el.$noData.find('.btn-inquiry').show();
                }

                allianceSearch.data.selectedPartner = null;
                lgkorUI.hideLoading();
            });
        }
    };

    $(document).ready(function() {
        allianceSearch.init();
    });

    var partnerRowTmpl =
        '{{#each (item, index) in partnerList}}' +
        '<div class="row" data-partner_cd="{{item.partnerCd}}" data-partner_nm="{{item.partnerNm}}" data-email_domain="{{item.emailDomain}}" data-auth_type="{{item.authType}}" data-auth_type_text="{{item.authTypeText}}">\n' +
        '    <div class="col-table">\n' +
        '        <div class="col col2">\n' +
        '            <em class="mo-only">회사명</em><span>{{item.partnerNm}}</span>\n' +
        '        </div>\n' +
        '        <div class="col col3">\n' +
        '            <em class="mo-only">사업자등록번호</em><span>{{item.dispCorpNo}}</span>\n' +
        '        </div>\n' +
        '        <div class="col col4">\n' +
        '            <em class="mo-only">인증방식</em><span>{{item.authTypeText}}</span>\n' +
        '        </div>\n' +
        '        <div class="col col5">\n' +
        '            <em class="mo-only">도메인</em><span>{{item.emailDomain}}</span>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>\n' +
        '{{/each}}';
})();
